
 
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onDataConnectionCreation = /* GraphQL */ `subscription OnDataConnectionCreation {
  onDataConnectionCreation {
    body {
      connectionId
      message
      __typename
    }
    statusCode
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDataConnectionCreationSubscriptionVariables,
  APITypes.OnDataConnectionCreationSubscription
>;
export const onDataConnectionTest = /* GraphQL */ `subscription OnDataConnectionTest {
  onDataConnectionTest {
    connectionId
    message
    status
    statusCode
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDataConnectionTestSubscriptionVariables,
  APITypes.OnDataConnectionTestSubscription
>;
export const onExecutionUpdateQueryRecords = /* GraphQL */ `subscription OnExecutionUpdateQueryRecords($engagement: String!) {
  onExecutionUpdateQueryRecords(engagement: $engagement) {
    CSVKey
    approvalStatus
    approvedBy
    athenaExecutionId
    createdAt
    createdBy
    description
    engagement
    executionDuration
    executionEndTime
    executionStartTime
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    metadataKey
    name
    orgType
    query
    queryId
    rejectReason
    syntheticResult
    type
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnExecutionUpdateQueryRecordsSubscriptionVariables,
  APITypes.OnExecutionUpdateQueryRecordsSubscription
>;
export const onModelUpdate = /* GraphQL */ `subscription OnModelUpdate {
  onModelUpdate {
    data {
      athenaExecutionId
      createdAt
      createdBy
      engagement
      images
      lastModifiedAt
      lastModifiedBy
      lookalikeNumber
      maxLookalikeNumber
      metadata
      modelId
      modelType
      name
      orgType
      parentId
      queryId
      queryName
      seedAudienceSize
      status
      __typename
    }
    statusCode
    statusMessage
    success
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnModelUpdateSubscriptionVariables,
  APITypes.OnModelUpdateSubscription
>;
export const onNotifyJobComplete = /* GraphQL */ `subscription OnNotifyJobComplete($jobId: String) {
  onNotifyJobComplete(jobId: $jobId) {
    body {
      aiComments
      generatedSql
      jobId
      status
      updatedAt
      __typename
    }
    jobId
    statusCode
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnNotifyJobCompleteSubscriptionVariables,
  APITypes.OnNotifyJobCompleteSubscription
>;
export const onUpdateQueryRecords = /* GraphQL */ `subscription OnUpdateQueryRecords($engagement: String!) {
  onUpdateQueryRecords(engagement: $engagement) {
    CSVKey
    approvalStatus
    approvedBy
    athenaExecutionId
    createdAt
    createdBy
    description
    engagement
    executionDuration
    executionEndTime
    executionStartTime
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    metadataKey
    name
    orgType
    query
    queryId
    rejectReason
    syntheticResult
    type
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateQueryRecordsSubscriptionVariables,
  APITypes.OnUpdateQueryRecordsSubscription
>;
export const onValidateQueryRecords = /* GraphQL */ `subscription OnValidateQueryRecords($engagement: String!) {
  onValidateQueryRecords(engagement: $engagement) {
    CSVKey
    approvalStatus
    approvedBy
    athenaExecutionId
    createdAt
    createdBy
    description
    engagement
    executionDuration
    executionEndTime
    executionStartTime
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    metadataKey
    name
    orgType
    query
    queryId
    rejectReason
    syntheticResult
    type
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnValidateQueryRecordsSubscriptionVariables,
  APITypes.OnValidateQueryRecordsSubscription
>;
